import { render, staticRenderFns } from "./MatterFilter.vue?vue&type=template&id=678fd21b&scoped=true&"
import script from "./MatterFilter.vue?vue&type=script&lang=js&"
export * from "./MatterFilter.vue?vue&type=script&lang=js&"
import style0 from "./MatterFilter.vue?vue&type=style&index=0&id=678fd21b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fd21b",
  null
  
)

export default component.exports